/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonUserBaseFromJSON, InternalCommonUserBaseToJSON, } from './InternalCommonUserBase';
/**
 * @export
 */
export const InternalUserForumDiscussionResponseV3TypeEnum = {
    ForumDiscussion: 'forum_discussion'
};
/**
 * Check if a given object implements the InternalUserForumDiscussionResponseV3 interface.
 */
export function instanceOfInternalUserForumDiscussionResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    return true;
}
export function InternalUserForumDiscussionResponseV3FromJSON(json) {
    return InternalUserForumDiscussionResponseV3FromJSONTyped(json, false);
}
export function InternalUserForumDiscussionResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'sanitizedContent': json['sanitized_content'] == null ? undefined : json['sanitized_content'],
        'coverPicture': json['cover_picture'] == null ? undefined : json['cover_picture'],
        'user': json['user'] == null ? undefined : InternalCommonUserBaseFromJSON(json['user']),
    };
}
export function InternalUserForumDiscussionResponseV3ToJSON(json) {
    return InternalUserForumDiscussionResponseV3ToJSONTyped(json, false);
}
export function InternalUserForumDiscussionResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'title': value['title'],
        'sanitized_content': value['sanitizedContent'],
        'cover_picture': value['coverPicture'],
        'user': InternalCommonUserBaseToJSON(value['user']),
    };
}
